<template>
  <div class="index">
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>基本信息</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="8">
          <div>
            <div class="key">商品编码：</div>
            <div class="value">{{get.code}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">商品名称：</div>
            <div class="value" style="max-width: 180px;">{{get.name}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">分类编码：</div>
            <div class="value">{{get.categoryCode}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="8">
          <div>
            <div class="key">商品分类：</div>
            <div class="value" :title="category.length && category.join('·')">
              <span v-for="(item, i) in category">
                <a v-if="i === 3" class="active" @click="goDashboard">{{item}}</a>
                <span v-else>{{item}}·</span>
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div>
            <div class="key">区域化品名：</div>
            <div class="value">{{get.alias}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.images">
        <el-col :span="24">
          <div>
            <div class="key">商品图片：</div>
            <div class="value">
              <ProductImages :images="get.images" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">商品属性：</div>
            <div class="value">{{get.features}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">存储方法：</div>
            <div class="value">{{get.storageMeans}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.storageMeansImages">
        <el-col :span="24">
          <div>
            <div class="key">存储方法图片：</div>
            <div class="value">
              <ProductImages :images="get.storageMeansImages" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>生长习性</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">商品产地</div>
            <div class="value">{{get.place}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.placeImages">
        <el-col :span="24">
          <div>
            <div class="key">商品产地图片：</div>
            <div class="value">
              <ProductImages :images="get.placeImages" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">生长周期：</div>
            <div class="value">{{get.lifeCycles}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.lifeCyclesImages">
        <el-col :span="24">
          <div>
            <div class="key">生长周期图片：</div>
            <div class="value">
              <ProductImages :images="get.lifeCyclesImages" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">上市时间：</div>
            <div class="value">{{get.timeToMarket}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">加工流程：</div>
            <div class="value">{{get.processFlow}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.processFlowImages">
        <el-col :span="24">
          <div>
            <div class="key">加工流程图片：</div>
            <div class="value">
              <ProductImages :images="get.processFlowImages" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">验收标准：</div>
            <div class="value">{{get.acceptanceStandard}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.acceptanceStandardImages">
        <el-col :span="24">
          <div>
            <div class="key">验收标准图片：</div>
            <div class="value">
              <ProductImages :images="get.acceptanceStandardImages" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>食赏妙味</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">挑选窍门：</div>
            <div class="value">{{get.chooseTrick}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.chooseTrickImages">
        <el-col :span="24">
          <div>
            <div class="key">挑选窍门图片：</div>
            <div class="value">
              <ProductImages :images="get.chooseTrickImages" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">食用方法：</div>
            <div class="value">{{get.edibleMethods}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.edibleMethodsImages">
        <el-col :span="24">
          <div>
            <div class="key">食用方法图片：</div>
            <div class="value">
              <ProductImages :images="get.edibleMethodsImages" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>商品故事</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">商品故事：</div>
            <div class="value">{{get.story}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.storyImages">
        <el-col :span="24">
          <div>
            <div class="key">商品故事图片：</div>
            <div class="value">
              <ProductImages :images="get.storyImages" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>商品营销</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">主题营销：</div>
            <div class="value">{{get.themeMarketing}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.themeMarketingLinks">
        <el-col :span="24">
          <div>
            <div class="key">营销软文链接：</div>
            <div class="value">
              <a :href="get.themeMarketingLinks" target="_blank">{{get.themeMarketingLinks}}</a>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ProductImages from "@/components/ProductImages.vue";
export default {
  name: "ProductBase",
  components: {
    ProductImages
  },
  props: ["get", "category"],
  methods: {
      goDashboard() {
          this.$router.push(`/product/dashboard/${this.$route.params.id}?source=category`)
      },
  }
};
</script>

<style lang="less" scoped>
.index {
  width: 1100px;

  font-size: 14px;

  .title {
    margin: 20px 0;
    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }
    div {
      display: inline-block;
      width: 80px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .row {
    line-height: 20px;
    min-height: 50px;
    padding: 15px 20px;
    .active{
      cursor: pointer;
      color: #1B994F;
    }
  }

  .content .row:nth-child(2n + 1) {
    background: #f7faf8;
  }

  // .row-dark {
  //   background: #f7faf8;
  // }

  .key {
    display: inline-block;
    width: 100px;
    color: #666;
    vertical-align: top;
  }
  .value {
    display: inline-block;
    max-width: 960px;
    color: #333;
  }
}
</style>
